"use client"

import React, {FC, use} from 'react';
import {observer} from "mobx-react";
import styles from "./styles/SchoolFeedDisplay.module.scss";
import {IFallbackData, ISchoolFeedUrlQueries} from "../../utils/SchoolBlocksUtilities";
import {useSchoolFeedInfiniteScroll} from "./hooks/useSchoolFeedInfiniteScroll";
import {IReactiveNewsContentItem} from "./SchoolFeedContentItem";
import {FetchMoreNewsButton} from "../blocks/TerracedGridTheme/NewsBlock/FetchMoreNewsButton";
import SchoolFeedList from "./ContentPostDisplay/SchoolFeedList";
import PlaceholderNewsItem from "../../assets/images/placeholders/placeholder-news-item.svg";

const SchoolFeedNewsDisplay: FC<{
    urlQuery: ISchoolFeedUrlQueries,
    initialNewsPromise?: Promise<IFallbackData>,
}> = observer((props) => {
    const {
        contentItems,
        totalContentItems,
        getItemAtIndex,
        showViewMore,
        isValidating,
        setSize,
        mutate,
        isLoading,
    } = useSchoolFeedInfiniteScroll(
        "news",
        {
            is_news: true,
            page_size: 10,
        },
        props.initialNewsPromise ? use(props.initialNewsPromise) : undefined,
    )

    async function handleDeleteContentItem() {
        await mutate();
    }

    const fetchNews = async () => {
        await setSize(s => s + 1);
    }

    return <div className={styles.newsFeedContainer}>
        {(isLoading && contentItems.length === 0) ?  <SchoolFeedNewsLoading /> : <>
            <SchoolFeedList
                showMedia={true}
                allowCuration={true}
                content={contentItems as IReactiveNewsContentItem[]}
                totalItemCount={totalContentItems}
                handleDelete={handleDeleteContentItem}
                className={styles.schoolFeedList}
                getItemAtIndex={getItemAtIndex}
            />
        {showViewMore && <FetchMoreNewsButton onClick={fetchNews} isLoading={isValidating}/>}
        </>}
    </div>
})

export default SchoolFeedNewsDisplay;

export function SchoolFeedNewsLoading() {
    return <div className={styles.newsLoading}>
        {/*@ts-ignore*/}
        <img src={PlaceholderNewsItem} alt="Placeholder News Item"/>
        {/*@ts-ignore*/}
        <img src={PlaceholderNewsItem} alt="Placeholder News Item"/>
        {/*@ts-ignore*/}
        <img src={PlaceholderNewsItem} alt="Placeholder News Item"/>
        {/*@ts-ignore*/}
        <img src={PlaceholderNewsItem} alt="Placeholder News Item"/>
    </div>
}
